import { render, staticRenderFns } from "./ConfirmCopyingSyllabusCopyMethods.vue?vue&type=template&id=08d8cc19&"
import script from "./ConfirmCopyingSyllabusCopyMethods.vue?vue&type=script&lang=js&"
export * from "./ConfirmCopyingSyllabusCopyMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports